import { Injectable } from '@angular/core';
import { Facility } from '@resparke/models/client-types';
import { Observable, tap } from 'rxjs';
import { ApiService } from 'shared/services/api/api.service';
import { AppStateService } from 'shared/services/app-state/app-state.service';

@Injectable({
  providedIn: 'root'
})
export class FacilityService {

  constructor(
    private apiService: ApiService,
    private appState: AppStateService,
  ) { }


  getFacility(id: string): Observable<Facility> {
    const statement = `
      query getFacility($id: ID!) {
        getFacility(id: $id) {
          id
          name
          addOns
          displayName
          logo
          country
          legacyFacilityId
        }
      }
    `;
    return this.apiService
      .graphql<Facility>({ statement, variables: { id }, type: 'getFacility'})
      .pipe(
        tap(facility => {
          this.appState.set('currentFacility', facility);
        })
      )

  }
}
